'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dView$002dRecipe$002dApp$002dPage from "./mealorama.-App-Router$-View-Recipe-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$ViewRecipeAppPage$() {
}
export { $c_Lmealorama_AppRouter$ViewRecipeAppPage$ as $c_Lmealorama_AppRouter$ViewRecipeAppPage$ };
$p = $c_Lmealorama_AppRouter$ViewRecipeAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$ViewRecipeAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$ViewRecipeAppPage$() {
}
export { $h_Lmealorama_AppRouter$ViewRecipeAppPage$ as $h_Lmealorama_AppRouter$ViewRecipeAppPage$ };
$h_Lmealorama_AppRouter$ViewRecipeAppPage$.prototype = $p;
$p.m = (function() {
  return "ViewRecipeAppPage";
});
$p.aS8 = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dView$002dRecipe$002dApp$002dPage.$c_Lmealorama_AppRouter$ViewRecipeAppPage($x_1.l, $x_1.h);
});
var $d_Lmealorama_AppRouter$ViewRecipeAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$ViewRecipeAppPage$, "mealorama.AppRouter$ViewRecipeAppPage$", ({
  FB: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$ViewRecipeAppPage$ as $d_Lmealorama_AppRouter$ViewRecipeAppPage$ };
var $n_Lmealorama_AppRouter$ViewRecipeAppPage$;
function $m_Lmealorama_AppRouter$ViewRecipeAppPage$() {
  if ((!$n_Lmealorama_AppRouter$ViewRecipeAppPage$)) {
    $n_Lmealorama_AppRouter$ViewRecipeAppPage$ = new $c_Lmealorama_AppRouter$ViewRecipeAppPage$();
  }
  return $n_Lmealorama_AppRouter$ViewRecipeAppPage$;
}
export { $m_Lmealorama_AppRouter$ViewRecipeAppPage$ as $m_Lmealorama_AppRouter$ViewRecipeAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-View-Recipe-App-Page$.js.map
